export const popups = {
  registerRequest: {
    title: 'Registration request',
    description: 'Fill out the form and we will contact you.',
    button: 'Submit registration request',
    form: {
      noteLabel: 'How did you hear about us?',
      notePlaceholder: 'How did you hear about us?',
      checkboxExperience: 'I have club experience',
      club: {
        nameLabel: 'Club name',
        namePlaceholder: 'Club name'
      }
    }
  },
  invite: {
    title: 'Confirm age',
    description: 'Are you over 18 years? Confirm your age to use the platform.',
    confirm: 'Yes, I am over 18'
  },
  deleteAccount: {
    title: 'Delete your account?',
    subTitle:
      'Are you sure you want to delete your account? Deletion cannot be undone.',
    description:
      'You can hide your profile instead. It will stay hidden from everyone except you until you decide to reopen it.'
  },
  exitFromProfile: {
    title: 'Log out?',
    description: 'Confirm that you want to log out.'
  },
  hideAccount: {
    title: 'Hide profile?',
    description:
      'Your profile will not be visible to anyone except you until you decide to reopen it.'
  },
  mainPhoto: {
    title: 'Cover photo',
    description: 'Choose a cover photo for your resume'
  },
  updateVideo: {
    title: 'Video upload',
    description: 'Please wait for the video to upload'
  },
  consumation: {
    title: 'Consumption',
    description:
      'Enter the five most popular consumption items, their prices, and the percentage paid to the artist.'
  },
  crazyMenu: {
    title: 'Crazy menu',
    description:
      'Enter the five most popular crazy menu items and their prices.'
  },
  warningOnCloseOnboarding: {
    title: 'Are you sure ?',
    description:
      'Are you sure you want to stop filling in the details? You resume will not be published. Clubs will be unable to send you their best offers. You can continue filling it in later.'
  },
  foreignLanguage: {
    title: 'Proficiency level'
  },
  createWorkItem: {
    title: 'Confirmation',
    titleRequest: 'Confirmation',
    inviteDescription:
      'These details are provisional. You can discuss them in the chat with the artist and update the invitation.',
    requestDescription:
      'These details are provisional. You can discuss them in the chat with the club and update the request.',
    suggestVacancy: 'Suggest a vacancy for the artist',
    selectVacancy: 'Specify the vacancy of interest',
    ticketCreditOption: 'Ticket credit option',
    ticketCreditRequired: 'Is ticket credit required?'
  },
  clubWorkInteraction: {
    artistWorkAtClub: 'The artist is working at your club.',
    setLastDay: {
      title: 'Set last day?',
      setLastWorkDate: 'Select the artist’s last working day',
      description:
        'Once you set the last date for the artist, it cannot be changed. After that date the artist will finish the contract with your club.'
    },
    artistArrival: {
      title: 'Confirm arrival?',
      description: 'You confirm the artist’s presence at your club.',
      information:
        'Work will begin once you confirm the artist’s presence at the workplace.'
    },
    workCancel: {
      title: 'Confirm',
      description: 'You confirm the cancellation of the contract.'
    },
    wantEndDate: {
      title: 'The artist wants to set a last working day.'
    },
    newEndDate: {
      title: 'Last working day'
    }
  },
  artistWorkInteraction: {
    manageCurentContract: {
      pendingLastWorkDateRequest:
        'Your request to end the contract is under review.',
      workStartOnArtistArrivalConfirm:
        'Work will begin once the club confirms your presence at the workplace.',
      weCanRequestLastWorkDate:
        'Request your contract end date from the club.',
      clubSetLastWorkDate:
        'The club has set your last working day at this club.'
    }
  },
  changeProfile: {
    title: 'My clubs'
  },
  confirmOnboardingCompletion: {
    title: 'Your portfolio has been published',
    description: 'Clubs can now invite you to work.'
  },
  videoUploading: {
    title: 'Video upload',
    description: 'Please wait for the video to upload'
  },
  addWorkItem: {
    title: 'Place of work',
    vacancyQuestion: 'Which vacancy did you work in?',
    validationMessage:
      'You have already indicated that you are currently working.'
  },
  selectMainPhoto: {
    title: 'Main photo',
    description: 'Choose a cover photo for your CV'
  },
  deleteWorkExperience: {
    title: 'Delete?',
    description: 'Are you sure you want to delete this work experience?'
  }
};
